// import { AgGridReact } from "ag-grid-react";
import { Breadcrumb } from "@gull";
import { Helmet } from "react-helmet";
import { AiFillFileExcel, AiOutlineCopy } from "react-icons/ai";
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import queryStringService from "app/services/queryStringService";
import { exportLedger, getTransactionLogAll } from "app/services/SearchService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdOutlineRefresh, MdSearch } from "react-icons/md";

import HandyScroll from "app/common/Scroll";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import { totalAmountService } from "app/services/memberService";
import MemberAutoComplete from "./Components/MemberAutoComplete";

const TransactionHistory = () => {
  const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";
  const [totalCreditDebitAmount, setTotalCreditDebitAmount] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    FromDate: "",
    ToDate: "",
    TransactionMode: "",
    memId: 0,
  });

  useEffect(() => {
    loadTransactionLog();
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    state.page,
    state.sizePerPage,
    // state.FromDate,
    // state.ToDate,
    // state.TransactionMode,
  ]);

  const dateFormater = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  const ledgerFormatter = (cell, row) => {
    return moment(row.ladgerDate).format(dateTimeFormat);
  };

  const transactionModeFormatter = (cell, row) => {
    if (row.transactionMode === "Debit") {
      return (
        <div>
          <span className="text-danger">Debit</span>{" "}
          <img
            src="/assets/images/debit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    } else {
      return (
        <div>
          <span className="text-success">Credit</span>
          <img
            src="/assets/images/credit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    }
  };

  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.transactionAmount} </span>;
  };

  const leadgerBalanceFormatter = (cell, row) => {
    return <span> ₹ {row.leadgerBalance} </span>;
  };

  const openingFormatter = (cell, row) => {
    return <span> ₹ {row.opening} </span>;
  };

  const closingFormatter = (cell, row) => {
    return <span> ₹ {row.closing} </span>;
  };

  const tooltipFormatter = (cell, row) => {
    return (
      cell && (
        <Tooltip
          placement="top"
          overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
        >
          {/* <span>{cell.substring(0, 10)}...</span> */}
          <span style={{ whiteSpace: "nowrap" }}>
            {cell.substring(0, 10)}...
            <AiOutlineCopy
              className="ml-1"
              onClick={async () => {
                if ("clipboard" in navigator) {
                  await navigator.clipboard.writeText(cell);
                  NotificationManager.success(
                    "Copied successfully ",
                    "Success",
                    5000
                  );
                }
              }}
            />
          </span>
        </Tooltip>
      )
    );
  };

  const creditFormatter = (cell, row) => {
    if (row.creditBalance === 0 || row.creditBalance === null) {
      return <span> ₹ 0 </span>;
    } else {
      return <span> ₹ {row.creditBalance} </span>;
    }
  };

  const columns = [
    {
      dataField: "sln",
      text: "Trn Id",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "80px" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "150px" };
      },
    },
    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionDate",
      text: "Trn Date",
      headerStyle: (colum, colIndex) => {
        return { width: "220px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    // {
    //   dataField: "ladgerDate",
    //   text: "Approval Date",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "220px", textAlign: "center" };
    //   },
    //   formatter: ledgerFormatter,
    // },
    {
      dataField: "refNo",
      text: "Ref No",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },
    {
      dataField: "correlationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: tooltipFormatter,
    },
    {
      dataField: "transactionType",
      text: "Trn Type",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Trn Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: transactionAmountFormatter,
    },
    {
      dataField: "transactionMode",
      text: "Trn Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: transactionModeFormatter,
    },
    {
      dataField: "opening",
      text: "Opening",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: openingFormatter,
    },
    {
      dataField: "closing",
      text: "Closing",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: closingFormatter,
    },
    {
      dataField: "creditBalance",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: creditFormatter,
    },
    {
      dataField: "leadgerBalance",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: leadgerBalanceFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    const { loading } = state;
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransactionLog = async (pageParam, sizePerPageParam) => {
    const { page, sizePerPage, FromDate, ToDate, TransactionMode, memId } =
      state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: pageParam ? pageParam : page,
      pageSize: sizePerPageParam ? sizePerPageParam : sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
      memId,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await getTransactionLogAll(query);

    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prevState) => ({
      ...prevState,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };
  const loadTotalAmount = async () => {
    const { FromDate, ToDate, TransactionMode, memId } = state;
    const totalAmountReq = {
      memId: memId,
      fromDate: FromDate,
      toDate: ToDate,
      transactionType: "Accounting",
      transactionStatus: TransactionMode,
    };
    const totalAmountRes = await totalAmountService(totalAmountReq);
    const totalCredit = totalAmountRes?.data?.totalCreditAmount;
    const totalDebit = totalAmountRes?.data?.totalDebitAmount;
    setTotalCreditDebitAmount({
      credit: totalCredit,
      debit: totalDebit,
    });
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    await loadTransactionLog(page, sizePerPage);
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  };

  const resetTableHandler = async () => {
    const { page, sizePerPage, FromDate, ToDate, TransactionMode, memId } =
      state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: 1,
      pageSize: 10,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await getTransactionLogAll(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prevState) => ({
      ...prevState,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  };

  const handleSearch = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));

    await loadTransactionLog();
    setTimeout(() => {
      loadTotalAmount();
    }, 100);
  };

  const handleExport = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await exportAllLedger();
    }, 10);
  };

  const exportAllLedger = async () => {
    const { page, sizePerPage, FromDate, ToDate, TransactionMode, memId } =
      state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
      memId,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await exportLedger(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_ladger.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
  };

  const handleSearchChanges = (e) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const refreshFilter = async (e) => {
    setState((prevState) => ({
      ...prevState,
      FromDate: "",
      ToDate: "",
      TransactionMode: "",
      memId: 0,
    }));

    setSelectedValue(null);

    // Wait for the state update to complete
    setTimeout(() => {
      resetTableHandler();
    }, 0);
  };

  const {
    data,
    sizePerPage,
    page,
    dataCount,
    loading,
    FromDate,
    ToDate,
    TransactionMode,
    memId,
  } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Transaction History</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[{ name: "Transaction History" }]}
      ></Breadcrumb>
      <div className="card card-body text-left " id="transactionHistory">
        <div className="card-body p-0 mr-2 ">
          <Row>
            <Col lg={12} xs={12} sm={12} md={12}>
              {totalCreditDebitAmount != null && (
                <div className="float-end">
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    <span className="text-success">Total Credit Amount:</span> ₹{" "}
                    {Number(totalCreditDebitAmount?.credit ?? 0).toFixed(2)}
                  </span>
                  <span
                    className="me-2 ms-2"
                    style={{
                      fontSize: 18,
                      fontWeight: "inherit",
                      color: "gray",
                    }}
                  >
                    |
                  </span>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    <span className="text-danger">Total Debit Amount:</span> ₹{" "}
                    {Number(totalCreditDebitAmount?.debit ?? 0).toFixed(2)}
                  </span>
                </div>
              )}
            </Col>
            <Col lg={12} xs={12} sm={12} md={12}>
              <div>
                <div className="mx-auto">
                  <div className="bookingList-header">
                    <div className="row g-3">
                      {/* Date From */}
                      <div className="col-lg-2 col-md-4 col-12">
                        <div className="form-group">
                          <label className="mb-2">Date From</label>
                          <input
                            type="date"
                            className="form-control"
                            name="FromDate"
                            value={FromDate}
                            onChange={handleSearchChanges}
                            max={moment().format("YYYY-MM-DD")}
                          />
                        </div>
                      </div>

                      {/* Date To */}
                      <div className="col-lg-2 col-md-4 col-12">
                        <div className="form-group">
                          <label className="mb-2">Date To</label>
                          <input
                            type="date"
                            className="form-control"
                            name="ToDate"
                            value={ToDate}
                            onChange={handleSearchChanges}
                            max={moment().format("YYYY-MM-DD")}
                          />
                        </div>
                      </div>

                      {/* Transaction Mode */}
                      <div className="col-lg-2 col-md-4 col-12">
                        <div className="form-group">
                          <label className="mb-2">Transaction Mode</label>
                          <select
                            className="form-select"
                            name="TransactionMode"
                            value={TransactionMode}
                            onChange={handleSearchChanges}
                          >
                            <option value="">Select Transaction Mode</option>
                            <option value="Debit">Debit</option>
                            <option value="Credit">Credit</option>
                          </select>
                        </div>
                      </div>

                      {/* Member Name */}
                      <div className="col-lg-4 col-md-4 col-12">
                        <div className="form-group">
                          {/* {state.memId} */}
                          <label>Member Name</label>
                          <MemberAutoComplete
                            selectedValue={selectedValue}
                            setSelectedValue={setSelectedValue}
                            name="memId"
                            state={state}
                            setState={setState}
                          />
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="col-lg-2 col-md-12 col-12 d-flex justify-content-end align-items-center gap-2 pt-2">
                        <button
                          className="btn btn-outline-primary"
                          onClick={handleSearch}
                        >
                          <MdSearch size={18} />
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={refreshFilter}
                        >
                          <MdOutlineRefresh size={18} />
                        </button>
                        <Button
                          variant="outline-primary"
                          onClick={handleExport}
                          disabled={!dataCount}
                        >
                          <AiFillFileExcel size={18} />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <HandyScroll>
            <div
              class="spacious-container"
              data-handy-scroll
              style={{ overflow: "auto" }}
            >
              <BootstrapTable
                hover
                remote
                keyField="sln"
                data={data}
                columns={columns}
                pagination={paginationFactory(paginationOptions)}
                onTableChange={handleTableChange}
                noDataIndication={() => <NoDataIndication />}
                loading={loading}
                // overlay={overlayFactory({
                //   spinner: true,
                //   styles: {
                //     overlay: (base) => ({
                //       ...base,
                //       background: "rgba(120, 120, 120, 0.5)",
                //       zIndex: "1",
                //     }),
                //   },
                // })}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                rowStyle={rowStyle}
              />
            </div>
          </HandyScroll>
        </div>
      </div>
    </>
  );
};

export default TransactionHistory;
